import { render, staticRenderFns } from "./SmallPreview.vue?vue&type=template&id=7b1a6d47"
import script from "./SmallPreview.vue?vue&type=script&lang=js"
export * from "./SmallPreview.vue?vue&type=script&lang=js"
import style0 from "./SmallPreview.vue?vue&type=style&index=0&id=7b1a6d47&prod&lang=stylus"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports